module.exports = __webpack_public_path__ + "img/noData.6e2a827c.png";